import React from 'react';
import styled from 'styled-components';
import FranchiseImg from '../../assets/images/topFranchise.svg';
import BuyBrandImg from '../../assets/images/buyBrand.svg';
import BeBossImg from '../../assets/images/beBoss.svg';
import SberImg from '../../assets/images/sber.svg';
import PartnerkinImg from '../../assets/images/partnerkin.svg';

const FranchisePartners = () => {
  return (
    <FranchisePartnersContainer>
      <FranchisePartner
        href="https://topfranchise.ru/products/franshiza-avtomatizirovannogo-prokata-zaryadok-energo/"
        target="_blank"
      >
        <FranchiseImage src={FranchiseImg} alt="franchise"></FranchiseImage>
      </FranchisePartner>
      <FranchisePartner
        href="https://buybrand.ru/franshises/rest-rental-service/energo/"
        target="_blank"
      >
        <FranchiseImage src={BuyBrandImg} alt="buyBrand"></FranchiseImage>
      </FranchisePartner>
      <FranchisePartner
        href="https://www.beboss.ru/franchise/4025-franshiza-energo"
        target="_blank"
      >
        <FranchiseImage src={BeBossImg} alt="buyBrand"></FranchiseImage>
      </FranchisePartner>
      <FranchisePartner
        href="https://www.sberbank.ru/ru/s_m_business/franchises/detail/energo"
        target="_blank"
      >
        <FranchiseImage src={SberImg} alt="buyBrand"></FranchiseImage>
      </FranchisePartner>
      <FranchisePartner
        href="https://f.partnerkin.com/c/franchise_energo"
        target="_blank"
      >
        <FranchiseImage src={PartnerkinImg} alt="buyBrand"></FranchiseImage>
      </FranchisePartner>
    </FranchisePartnersContainer>
  );
};

const FranchisePartnersContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-top: 53px;
  justify-content: space-between;
  margin-bottom: -29px;
  @media (max-width: 1135px) {
    justify-content: center;
    column-gap: 18px;
    row-gap: 50px;
  }
  @media (max-width: 599px) {
    row-gap: 41px;
  }
`;

const FranchisePartner = styled.a`
  width: 18%;
  height: 96px;
  cursor: pointer;
  background: #ffffff;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  &:hover {
    border: 2px solid #a2a8b0;
  }
  @media (max-width: 1135px) {
    width: 31%;
  }
  @media (max-width: 599px) {
    width: 47%;
  }
`;

const FranchiseImage = styled.img`
  width: 90%;
  height: 35%;
  @media (max-width: 1135px) {
    width: 85%;
    height: 32%;
  }
`;

export default FranchisePartners;
